export const containerStyle = {
  height: "48px",
};

export const mediaPlaceholderContainerStyle = {
  width: 48,
  height: 48,
  borderRadius: "4px",
};
